window.debounce =
  window.debounce ||
  function (callback, wait) {
    let timeoutId;
    return function (...args) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => callback.apply(this, args), wait || 300);
    };
  };

if (!customElements.get("predictive-search")) {
  class e extends HTMLElement {
    constructor() {
      super(),
        (this.cachedResults = {}),
        (this.input = this.querySelector(".js-search-input")),
        (this.resetBtn = this.querySelector(".js-search-reset")),
        (this.results = this.querySelector(".js-search-results")),
        (this.overlay = this.querySelector(".js-search-overlay")),
        (this.statusEl = this.querySelector(".js-search-status")),
        (this.loadingText = this.getAttribute("data-loading-text")),
        this.addListeners();
    }
    disconnectedCallback() {
      this.close();
    }
    addListeners() {
      this.input.addEventListener("focus", this.handleFocus.bind(this)),
        this.input.addEventListener(
          "input",
          debounce(this.handleInput.bind(this))
        ),
        this.querySelector(".search").addEventListener(
          "submit",
          this.handleSubmit.bind(this)
        );
    }
    getQuery() {
      return this.input.value.trim();
    }
    handleSubmit(e) {
      (!this.getQuery().length ||
        this.querySelector(
          '.predictive-search__item[aria-selected="true"]:not(.js-submit)'
        )) &&
        e.preventDefault();
    }
    handleInput() {
      this.input.setAttribute("value", this.input.value);
      let e = this.getQuery();
      if (!e.length) {
        this.close();
        return;
      }
      this.getResults(e);
    }
    handleFocus() {
      let e = this.getQuery();
      e.length &&
        ("true" === this.getAttribute("results")
          ? this.open()
          : this.getResults(e));
    }
    handleKeydown(e) {
      if (!e.target.matches(".tablist__tab"))
        switch ((this.getQuery().length || this.close(), e.key)) {
          case "ArrowUp":
          case "ArrowDown":
            e.preventDefault(),
              this.hasAttribute("open") && this.handleResultsNav(e.key);
            break;
          case "Enter":
            this.selectOption();
            break;
          case "Escape":
            this.close();
        }
    }
    handleResultsNav(e) {
      let t = this.querySelector(
          '[role="tabpanel"]:not([hidden]) [aria-selected="true"]'
        ),
        s = this.querySelectorAll(
          '[role="tabpanel"]:not([hidden]) .predictive-search__item'
        ),
        i = s[0];
      if ("ArrowUp" === e) {
        if (!t) return;
        i = t.previousElementSibling || s[s.length - 1];
      } else "ArrowDown" === e && t && (i = t.nextElementSibling || s[0]);
      if (((this.statusEl.textContent = ""), i)) {
        if (i === t) return;
        i.setAttribute("aria-selected", "true"),
          t && t.setAttribute("aria-selected", "false"),
          this.setLiveRegionText(i.textContent),
          this.input.setAttribute("aria-activedescendant", i.id);
      }
    }
    selectOption() {
      let e = this.querySelector('[aria-selected="true"] > .js-search-link');
      e && e.click();
    }
    async getResults(e) {
      let t = e.replace(" ", "-").toLowerCase();
      if ((this.setLiveRegionLoadingState(), this.cachedResults[t])) {
        this.renderResults(this.cachedResults[t]);
        return;
      }
      let s = "title,product_type,variants.title,vendor";
      theme.settings.pSearchIncludeSkus && (s += ",variants.sku"),
        theme.settings.pSearchIncludeTags && (s += ",tag");
      let i = `q=${encodeURIComponent(e)}`;
      (i += `&${encodeURIComponent("resources[limit]")}=${
        theme.settings.pSearchLimit
      }`),
        (i += `&${encodeURIComponent("resources[limit_scope]")}=${
          theme.settings.pSearchLimitScope
        }`),
        (i += `&${encodeURIComponent("resources[options][fields]")}=${s}`),
        (i += "&section_id=predictive-search");
      try {
        let r = await fetch(`${theme.routes.predictiveSearch}?${i}`);
        if (!r.ok) throw Error(r.status);
        let n = document.createElement("template");
        n.innerHTML = await r.text();
        let a = n.content.querySelector("#shopify-section-predictive-search"),
          l = a.innerHTML.replace(/psearch/g, this.input.id);
        (this.cachedResults[t] = l), this.renderResults(l);
      } catch (h) {
        throw (this.close(), h);
      }
    }
    setLiveRegionLoadingState() {
      this.setLiveRegionText(this.loadingText);
    }
    setLiveRegionText(e) {
      this.statusEl.setAttribute("aria-hidden", "false"),
        (this.statusEl.textContent = e),
        setTimeout(() => {
          this.statusEl.setAttribute("aria-hidden", "true");
        }, 1e3);
    }
    renderResults(e) {
      (this.results.innerHTML = e),
        this.setAttribute("results", !0),
        this.open();
    }
    open() {
      this.overlay.classList.add("is-visible"),
        (this.resetBtn.hidden = !1),
        this.input.setAttribute("aria-expanded", "true"),
        this.setAttribute("open", ""),
        document.body.classList.add("overlay-predictive-search"),
        (this.keydownHandler =
          this.keydownHandler || this.handleKeydown.bind(this)),
        (this.resetBtnClickHandler =
          this.resetBtnClickHandler || this.close.bind(this)),
        (this.overlayClickHandler =
          this.overlayClickHandler || this.close.bind(this)),
        this.addEventListener("keydown", this.keydownHandler),
        this.resetBtn.addEventListener("click", this.resetBtnClickHandler),
        this.overlay.addEventListener("click", this.overlayClickHandler);
    }
    close(e) {
      e &&
        e.target === this.resetBtn &&
        ((this.input.value = ""),
        this.removeAttribute("results"),
        this.input.focus());
      let t = this.querySelector(
        '.predictive-search__item[aria-selected="true"]'
      );
      t && t.setAttribute("aria-selected", "false"),
        this.removeAttribute("open"),
        (this.resetBtn.hidden = !0),
        this.overlay.classList.remove("is-visible"),
        this.input.setAttribute("aria-activedescendant", ""),
        this.input.setAttribute("aria-expanded", "false"),
        document.body.classList.remove("overlay-predictive-search"),
        this.removeEventListener("keydown", this.keydownHandler),
        this.resetBtn.removeEventListener("click", this.resetBtnClickHandler),
        this.overlay.removeEventListener("click", this.overlayClickHandler);
    }
  }
  customElements.define("predictive-search", e);
}
